/* eslint-disable max-classes-per-file */
import {
  MainTableFilterModel,
  PrintReportFilterModel,
} from 'src/app/shared/models/main-table-filter.model';
import { IRunTimeImportRequest } from '../models/run-time-import.model';
import { IRunTimeCounterUpdateRequest, IRunTimeRequest } from '../models/run-time.model';

export class LoadRunTimesForDepartment {
  static readonly type = '[Run Time] Load Run Times via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadRunTimeChildrenForTable {
  static readonly type = '[Run Time] Load Run Time Children for Table via Service';
  constructor(
    public id: string,
    public filter?: MainTableFilterModel
  ) {}
}

export class ClearRunTimeChildrenForTable {
  static readonly type = '[Run Time] Clear Run Time Children for Table';
}

export class LoadRunTimesForDepartmentMinimal {
  static readonly type = '[Run Time] Load Minimal Run Times via service for dropdown';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllRunTimesForDepartment {
  static readonly type = '[Run Time] Load All Run Times via Service';
  constructor(public includeChildren?: boolean) {}
}

export class LoadRunTimeById {
  static readonly type = '[Run Time] Load a single run time';
  constructor(public id: string) {}
}

export class CreateRunTime {
  static readonly type = '[Run Time] Create run time';
  constructor(public runTime: IRunTimeRequest) {}
}

export class CreateRunTimeChild {
  static readonly type = '[Run Time] Create run time child';
  constructor(public runTime: IRunTimeRequest) {}
}

export class UpdateRunTime {
  static readonly type = '[Run Time] Update run time';
  constructor(public runTime: IRunTimeRequest) {}
}

export class ChangeRunTimeParent {
  static readonly type = '[Run Time] Change run time parent';
  constructor(
    public id: string,
    public parentRuntimeId?: string
  ) {}
}

export class UpdateRunTimeCounter {
  static readonly type = '[Run Time] Update run time counter';
  constructor(public runTime: IRunTimeCounterUpdateRequest) {}
}

export class UpdateOffset {
  static readonly type = '[Run Time] Update offset';
  constructor(public runTime: IRunTimeCounterUpdateRequest) {}
}

export class DeleteRunTime {
  static readonly type = '[Run Time] Delete run time';
  constructor(public id: string) {}
}

export class LoadRunTimeLog {
  static readonly type = '[Run Time] Load Runtime Log';
  constructor(public id: string) {}
}

export class ClearRunTimeLog {
  static readonly type = '[Run Time] Clear Runtime Log';
}

export class PrintRunTimeLog {
  static readonly type = '[Run Time] Print Runtime Log';
  constructor(public id: string) {}
}

export class PrintRunTimeReport {
  static readonly type = '[Run Time] Print Report';
  constructor(
    public filter?: PrintReportFilterModel,
    public menuId?: string,
    public includeChildren?: boolean
  ) {}
}

export class ImportRunTimes {
  static readonly type = '[Run Time] Import run times';
  constructor(public runTimeImport: IRunTimeImportRequest) {}
}

export class ClearCurrentRunTime {
  static readonly type = '[Run Time] Clear Current Run Time';
  constructor() {}
}
